import { defineStore } from 'pinia';

export interface IAuthState {
  csrfToken: string | null;
}

export const useAuthStore = defineStore('auth', {
  actions: {
    login(csrfToken: string): void {
      this.$patch((state) => {
        state.csrfToken = csrfToken;
      });
    },
  },

  state: (): IAuthState => ({
    csrfToken: null,
  }),

  persist: true,
});
